import React from "react";
import SnackApiError from "../components/snackbar/api-error";
import IconButton from "@material-ui/core/IconButton";
import IconClose from "@material-ui/icons/Close"


export const success = (message, enqueueSnackbar, closeSnackbar) => {
    enqueueSnackbar(message, {
        variant: 'success',
        autoHideDuration: 3000,
        action: (key) => (
            <IconButton onClick={() => { closeSnackbar(key) }}>
                <IconClose style={{color: 'white'}}/>
            </IconButton>
        ),
    })
}

export const apiError = (message, error, enqueueSnackbar) => {
    enqueueSnackbar(message, {
        autoHideDuration: 15000,
        content: (key, message) => (
            <SnackApiError id={key} message={message} error={error}/>
        )
    })
}
